import { render, staticRenderFns } from "./ManuscriptPreviewPage.vue?vue&type=template&id=01e41a6e&scoped=true&"
import script from "./ManuscriptPreviewPage.vue?vue&type=script&lang=ts&"
export * from "./ManuscriptPreviewPage.vue?vue&type=script&lang=ts&"
import style0 from "./ManuscriptPreviewPage.vue?vue&type=style&index=0&id=01e41a6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e41a6e",
  null
  
)

export default component.exports